<article id="portal">
  <router-outlet></router-outlet>
</article>
